import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-x-0 top-0 z-30 flex h-14 items-center justify-between gap-12 px-4 transition sm:px-6 lg:left-72 lg:z-30 lg:px-8 xl:left-80 backdrop-blur-sm dark:backdrop-blur lg:left-72 xl:left-80 bg-white/[var(--bg-opacity-light)] dark:bg-zinc-900/[var(--bg-opacity-dark)]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-x-0 top-full h-px transition bg-zinc-900/7.5 dark:bg-white/7.5" }, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "hidden lg:block lg:max-w-md lg:flex-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("kbd", { class: "ml-auto text-2xs text-zinc-400 dark:text-zinc-500" }, [
  /*#__PURE__*/_createElementVNode("kbd", { class: "font-sans" }, "Ctrl "),
  /*#__PURE__*/_createElementVNode("kbd", { class: "font-sans" }, "K")
], -1 /* HOISTED */)
const _hoisted_5 = { class: "flex items-center gap-5 lg:hidden" }
const _hoisted_6 = { class: "flex items-center gap-5" }
const _hoisted_7 = { class: "hidden md:block" }
const _hoisted_8 = {
  role: "list",
  class: "flex items-center gap-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MagnifyingGlassIcon = _resolveComponent("MagnifyingGlassIcon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_Bars3Icon = _resolveComponent("Bars3Icon")!
  const _component_HomeIcon = _resolveComponent("HomeIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_OutLink = _resolveComponent("OutLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        type: "button",
        class: "hidden h-8 w-full items-center gap-2 rounded-full bg-white pl-2 pr-3 text-sm text-zinc-500 ring-1 ring-zinc-900/10 transition hover:ring-zinc-900/20 dark:bg-white/5 dark:text-zinc-400 dark:ring-inset dark:ring-white/10 dark:hover:ring-white/20 lg:flex cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.displaySearchComboBox && _ctx.displaySearchComboBox(...args)))
      }, [
        _createVNode(_component_MagnifyingGlassIcon, {
          class: "pointer-events-none h-4 w-4 text-gray-400",
          "aria-hidden": "true"
        }),
        _createTextVNode("Search..."),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "button",
        class: "flex h-6 w-6 items-center justify-center rounded-md transition hover:bg-zinc-900/5 dark:hover:bg-white/5",
        "aria-label": "Toggle navigation",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNavigation && _ctx.toggleMobileNavigation(...args)))
      }, [
        (_ctx.mobileNavigationDisplayed)
          ? (_openBlock(), _createBlock(_component_XMarkIcon, {
              key: 0,
              class: "pointer-events-none h-4 w-4 text-gray-400",
              "aria-hidden": "true"
            }))
          : (_openBlock(), _createBlock(_component_Bars3Icon, {
              key: 1,
              class: "pointer-events-none h-4 w-4 text-gray-400",
              "aria-hidden": "true"
            }))
      ]),
      _createVNode(_component_router_link, {
        "aria-label": "Home",
        to: _ctx.Route.DOCS
      }, {
        default: _withCtx(() => [
          _createVNode(_component_HomeIcon, {
            class: "pointer-events-none h-4 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createVNode(_component_OutLink, {
        topClass: "ml-8 inline-block text-sm dark:text-zinc-400",
        imageClass: "h-4 inline-block rounded-full mr-2",
        labelClass: "inline-block align-middle leading-none"
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "flex h-6 w-6 items-center justify-center rounded-md transition hover:bg-zinc-900/5 dark:hover:bg-white/5 lg:hidden cursor-pointer",
        "aria-label": "Toggle navigation",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.displaySearchComboBox && _ctx.displaySearchComboBox(...args)))
      }, [
        _createVNode(_component_MagnifyingGlassIcon, {
          class: "pointer-events-none h-4 w-4 text-gray-400",
          "aria-hidden": "true"
        })
      ]),
      _createElementVNode("nav", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-sm leading-5 text-zinc-600 transition hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white",
              to: _ctx.docsRoute(_ctx.DocsRoute.EXAMPLES)
            }, {
              default: _withCtx(() => [
                _createTextVNode("Examples")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"])
          ]),
          _createCommentVNode(" <li>\n\t\t\t\t\t\t<router-link\n\t\t\t\t\t\t\tclass=\"text-sm leading-5 text-zinc-600 transition hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white\"\n\t\t\t\t\t\t\t:to=\"docsRoute(DocsRoute.API_INDEX)\"\n\t\t\t\t\t\t\t>API</router-link\n\t\t\t\t\t\t>\n\t\t\t\t\t</li> "),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-sm leading-5 text-zinc-600 transition hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white",
              to: _ctx.docsRoute(_ctx.DocsRoute.HELP)
            }, {
              default: _withCtx(() => [
                _createTextVNode("Help")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"])
          ])
        ])
      ]),
      _createCommentVNode(" <div class=\"hidden md:block md:h-5 md:w-px md:bg-zinc-900/10 md:dark:bg-white/15\"></div> "),
      _createCommentVNode(" <div class=\"flex gap-4\"> "),
      _createCommentVNode(" <div class=\"contents lg:hidden\">\n\t\t\t\t\t<button\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\tclass=\"flex h-6 w-6 items-center justify-center rounded-md transition hover:bg-zinc-900/5 dark:hover:bg-white/5 lg:hidden\"\n\t\t\t\t\t\taria-label=\"Find something...\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<svg\n\t\t\t\t\t\t\tviewBox=\"0 0 20 20\"\n\t\t\t\t\t\t\tfill=\"none\"\n\t\t\t\t\t\t\taria-hidden=\"true\"\n\t\t\t\t\t\t\tclass=\"h-5 w-5 stroke-zinc-900 dark:stroke-white\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\tstroke-linecap=\"round\"\n\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t\td=\"M12.01 12a4.25 4.25 0 1 0-6.02-6 4.25 4.25 0 0 0 6.02 6Zm0 0 3.24 3.25\"\n\t\t\t\t\t\t\t></path>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</button>\n\t\t\t\t</div> "),
      _createCommentVNode(" <button\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tclass=\"flex h-6 w-6 items-center justify-center rounded-md transition hover:bg-zinc-900/5 dark:hover:bg-white/5\"\n\t\t\t\t\taria-label=\"Toggle dark mode\"\n\t\t\t\t>\n\t\t\t\t\t<svg viewBox=\"0 0 20 20\" fill=\"none\" aria-hidden=\"true\" class=\"h-5 w-5 stroke-zinc-900 dark:hidden\">\n\t\t\t\t\t\t<path d=\"M12.5 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z\"></path>\n\t\t\t\t\t\t<path\n\t\t\t\t\t\t\tstroke-linecap=\"round\"\n\t\t\t\t\t\t\td=\"M10 5.5v-1M13.182 6.818l.707-.707M14.5 10h1M13.182 13.182l.707.707M10 15.5v-1M6.11 13.889l.708-.707M4.5 10h1M6.11 6.111l.708.707\"\n\t\t\t\t\t\t></path></svg\n\t\t\t\t\t><svg\n\t\t\t\t\t\tviewBox=\"0 0 20 20\"\n\t\t\t\t\t\tfill=\"none\"\n\t\t\t\t\t\taria-hidden=\"true\"\n\t\t\t\t\t\tclass=\"hidden h-5 w-5 stroke-white dark:block\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<path d=\"M15.224 11.724a5.5 5.5 0 0 1-6.949-6.949 5.5 5.5 0 1 0 6.949 6.949Z\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</button> "),
      _createCommentVNode(" </div> "),
      _createCommentVNode(" <div class=\"hidden min-[416px]:contents\">\n\t\t\t\t<a\n\t\t\t\t\tclass=\"inline-flex gap-0.5 justify-center overflow-hidden text-sm font-medium transition rounded-full bg-zinc-900 py-1 px-3 text-white hover:bg-zinc-700 dark:bg-emerald-400/10 dark:text-emerald-400 dark:ring-1 dark:ring-inset dark:ring-emerald-400/20 dark:hover:bg-emerald-400/10 dark:hover:text-emerald-300 dark:hover:ring-emerald-300\"\n\t\t\t\t\thref=\"/#\"\n\t\t\t\t\t>Sign in</a\n\t\t\t\t>\n\t\t\t</div> ")
    ])
  ]))
}